import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
//  added for code DDCFB
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FlyoutLoggedinUserComponent } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.component';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import { ContentBusinessType } from '../../model/content/contentbusinesstype.model';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { BusinessUserComponentHelper } from './business-user.component.helper';

@Component({
  selector: 'ngc-business-user',
  templateUrl: './business-user.component.html',
  providers: [BusinessUserComponentHelper]
})
export class BusinessUserComponent implements AfterViewInit, OnDestroy {
  bsModalRef: BsModalRef;
  modalServiceOnHiddenSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  public businessType: ContentBusinessType;
  public displayBusinessOnInitialLoad: any;
  displayTravelType = '';
  showNewProfileSelector = false;
  public corpPartner: ICorporatePartner;
  @Input() isAlertAdvisory?: boolean;
  @Input() hasBusinessOnly: any;
  @Input() alreadyLogged: boolean;
  @Input() isWarmState: boolean;
  @Input() crpInfo: any;
  @Output() modalServiceRef = new EventEmitter<any>();
  // @Output() accountType: EventEmitter<any> = new EventEmitter();
  config = {
    animated: false
  };

  @ViewChild('triggerElement1') triggerElement1: ElementRef;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private modalService: BsModalService,
    public el: ElementRef,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private srv: CommonService,
    private renderer: Renderer2,
    private loggingService: LoggingService,
    public switchingAccountService: SwitchingAccountService,
    public businessUserHelper: BusinessUserComponentHelper
  ) {}

  ngAfterViewInit() {
    this.contentHeaderFooterServiceSubscribe =
      this.contentService.contentHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              setTimeout(() => {
                this.showNewProfileSelector =
                  this.businessUserHelper.getProfileSelector(data);
                //   added timeout to get the updated loggedinFlag information
                this.businessType =
                  this.businessUserHelper.getBusinessType(data);
                let passCorpName = this.businessUserHelper.getPassCorpName(
                  this.hasBusinessOnly
                );
                this.switchingAccountService.setInitialBusinessType(
                  this.businessType,
                  passCorpName
                );
                setTimeout(() => {
                  this.displayTravelType =
                    this.businessUserHelper.getDisplayTravelType(
                      this.switchingAccountService,
                      this.switchingAccountService.businessAccount
                    );
                  this.displayBusinessOnInitialLoad =
                    this.switchingAccountService.getInitialBusinessType();
                  this.changeDetection.detectChanges();
                }, 10);
              }, 10);
            }
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    this.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        this.displayTravelType = this.businessUserHelper.getDisplayTravelType(
          this.switchingAccountService,
          corpPartner.showBusinessText
        );
        this.changeDetection.detectChanges();
      }
    );
  }

  openUserDetailsOnEnter(event) {
    if (event.which === 13 || (event.keyCode === 13 && this.alreadyLogged)) {
      this.openUserDetails(event);
    }
  }

  openUserDetails(e) {
    const bodyScroll = document.documentElement.scrollTop;
    e.preventDefault();
    let obj = this.businessUserHelper.setAlertAdvisoryClass(
      this.isAlertAdvisory
    );
    this.businessUserHelper.setBsModalRefClass(obj, this.crpInfo);
    this.businessUserHelper.setHtmlRootClass();
    this.modalServiceOnHiddenSubscribe =
      this.businessUserHelper.getModalServiceDataOnHidden();
    if (this.isAlertAdvisory) {
      obj = Object.assign({}, this.config, {
        class:
          'loggedIn-modal-dialog loggedIn-alertAdv-modal-dialog no-transform'
      });
    } else {
      obj = Object.assign({}, this.config, {
        class: 'loggedIn-modal-dialog no-transform'
      });
    }
    this.bsModalRef = this.modalService.show(FlyoutLoggedinUserComponent, obj);
    if (document.body.scrollWidth > 992) {
      this.bsModalRef.content.profilePickerModalLoaded = true;
      document
        .getElementsByTagName('modal-container')[0]
        .classList.add('notification-loggedin-modal');
      this.modalServiceRef.emit(this.bsModalRef);
    } else if (document.body.scrollWidth > 767) {
      this.bsModalRef.content.profilePickerModalLoaded = true;
      document
        .getElementsByTagName('modal-container')[0]
        .classList.add('notification-loggedin-modal');
    } else {
      this.bsModalRef.content.isFlyoutLoaded = true;
      document
        .getElementsByClassName('feed-header')[0]
        .classList.add('feed-header-fixed');
    }
    if (this.bsModalRef) {
      this.bsModalRef.content.focusActiveTab();
      this.bsModalRef.content.setModalHeight();
      this.bsModalRef.content.setCorpInfo(this.crpInfo);
      const flyToggle = this.el.nativeElement.querySelector('.toggle-flyout');
      flyToggle.className = 'toggle-flyout toggle-up';
    }
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
    this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (reason: string) => {
          this.triggerElement1.nativeElement.focus();
          const toggleFlyout =
            this.triggerElement1.nativeElement.querySelector('.toggle-flyout');
          if (toggleFlyout !== undefined) {
            toggleFlyout.className = 'toggle-flyout';
          }
          this.modalServiceRef.emit(null);
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.srv.dragModalContainers(this.el, this.renderer);
    document.documentElement.scrollTop = bodyScroll;
    this.srv.focusModalContainers(this.el, this.renderer);
  }

  toggleNewProfileSelectorModal() {
    this.businessUserHelper.setNewProfileSelectorModal();
    this.changeDetection.detectChanges();
  }

  ngOnDestroy() {
    // Loadtest ObsUnsub added
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.modalServiceOnHiddenSubscribe) {
      this.modalServiceOnHiddenSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
